<div class="row" *ngIf="!!asset">
    <!-- Asset Info -->
    <div class="col-12 col-xl form-inline pr-3 pr-xl-0">
        <div class="form-group">
            <label class="custom-form-label" for="modelName">{{ 'Asset.Model' | translate }}</label>
            <input class="form-control form-control-sm form-control-custom" type="text" id="modelName" [(ngModel)]="asset.modelName" (change)="saveAsset()">
        </div>
        <div class="form-group">
            <label class="custom-form-label" for="serialNumber">{{ 'Asset.SerialNumber' | translate }}</label>
            <input class="form-control form-control-sm form-control-custom" type="text" id="serialNumber" [(ngModel)]="asset.serialNumber" (change)="saveAsset()">
        </div>
        <div class="form-group">
            <label class="custom-form-label" for="assetYear">{{ 'Asset.Year' | translate }}</label>
            <input class="form-control form-control-sm form-control-custom" type="number" id="assetYear" [(ngModel)]="asset.year" (change)="saveAsset()">
        </div>
        <div class="form-group">
            <label class="custom-form-label" for="warrantyDate">{{ 'Asset.WarrantyDate' | translate }}</label>
            <div class="input-group align-items-center form-control-custom" id="fromDate">
                <input type="text"
                    #assetCardWarrantyDate="bsDatePicker"
                    class="form-contro"
                    bsDatePicker
                    name="warrantyDate"
                    placeholder="{{ 'Date.SelectDate' | translate }}"
                    [ngModel]="warrantyDate"
                    [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', showWeekNumbers: true, isAnimated: true, containerClass: 'theme-default' }"
                    (bsValueChange)="changeDate($event)">
                <div class="input-group-append">
                    <button type="button" class="btn btn-sm btn-secondary" (click)="assetCardWarrantyDate.show()">
                        <i class="far fa-calendar-alt"></i>
                    </button>
                </div>
              </div>
        </div>
        <div class="form-group">
            <label class="custom-form-label" for="categoryId">{{ 'Asset.AssetCategory' | translate }}</label>
            <select class="form-control form-control-sm form-control-custom" id="categoryId" [(ngModel)]="asset.category.id" (change)="saveAsset()">
                <option [ngValue]="null">{{ 'Standard.NoneChosen' | translate }}</option>
                <option [value]="x.id" *ngFor="let x of lists.categories">{{ x.name }}</option>
            </select>
        </div>
        <div class="form-group">
            <label class="custom-form-label" for="skillId">{{ 'Standard.Skills' | translate }}</label>
            <select class="form-control form-control-sm form-control-custom" id="skillId" [(ngModel)]="asset.skill.id" (change)="saveAsset()">
                <option [ngValue]="null">{{ 'Standard.NoneChosen' | translate }}</option>
                <option [value]="x.skillId" *ngFor="let x of lists.skills">{{ x.name }}</option>
            </select>
        </div>
        <div class="form-group">
            <label class="custom-form-label" for="assetRemark"> {{ 'Asset.Remark' | translate }}</label>
            <textarea class="form-control form-control-sm form-control-custom" it="assetRemark" rows="6" [(ngModel)]="asset.remark" (change)="saveAsset()"></textarea>
        </div>
    </div>
    <!-- QR Code -->
    <div class="col-12 col-xl-5 pt-md-2 pt-xl-0 qrCode" *ngIf="!!asset.labelId">
        <a [href]="'http://asset.jublo.com/assetDetails/' + asset.labelId" target="_blank">
        <ngx-qrcode-styling 
            [config]="qrOptions" 
            [type]="'svg'" 
            [data]="'http://asset.jublo.com/assetDetails/' + asset.labelId" 
            [width]="150" 
            [height]="150" 
            [qrOptions]="{errorCorrectionLevel: 'H'}" 
            [image]="'https://hv.jublo.com/wp-content/uploads/2021/09/Jublo_Logo_Haandvaerker_Mark_Farve-267x300.png'"></ngx-qrcode-styling>
        </a>
        <span *ngIf="!!asset.url">{{ 'Standard.LabelNo' | translate }}: {{ asset.url }}</span>
        <span class="mt-5" (click)="serialNumberInvalid = false; serialNumber = null; loading = false;" data-toggle="modal" [attr.data-target]="'#addSerialNumberModal-' + assetId">Skift label nr.</span>
    </div>
    <!-- NO QR Code -->
    <div class="col-12 col-xl-5 pt-md-2 pt-xl-0 qrCode qrCode-image" *ngIf="!asset.labelId">
        <img src="../../../assets/img/icons/qrcode.png" alt="No serial number" width="150" height="150">
        <div class="qrCode-image-text" (click)="serialNumberInvalid = false; serialNumber = null; loading = false;" data-toggle="modal" [attr.data-target]="'#addSerialNumberModal-' + assetId">{{ 'Asset.AddLabel' | translate }}</div>
    </div>
</div>

<!-- Add Serial Number Modal -->
<div class="modal fade" [attr.id]="'addSerialNumberModal-' + assetId" tabindex="-1" role="dialog" aria-labelledby="addSerialNumberModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="addSerialNumberModalLabel">{{ 'Word.Add' | translate }} {{ ('Asset.SerialNumber' | translate) | lowercase }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
          </button>
        </div>
        <div class="modal-body" *ngIf="!loading && !serialNumberAdded">
            <div class="form-group d-block">
                <label for="addSerialNumber">{{ 'Asset.SerialNumber' | translate }}</label>
                <input type="number" class="form-control" id="addSerialNumber" [ngClass]="{'is-invalid':serialNumberInvalid}" [(ngModel)]="serialNumber" placeholder="{{ 'Asset.EnterSerialNumber' | translate }}">
                <small class="invalid-feedback" *ngIf="serialNumberInvalid">{{ !!responseMessage ? responseMessage : ('Asset.InvalidSerialNumber' | translate) }}</small>
            </div>
        </div>
        <div class="modal-body d-flex justify-content-center m-3" *ngIf="loading">
            <i class="fas fa-spinner fa-2x fa-spin"></i>
        </div>
        <div class="modal-body d-flex justify-content-center m-3" *ngIf="!loading && serialNumberAdded">
            {{ 'Asset.SerialNumber' | translate }} {{ serialNumber }} {{ ('Asset.AddedToAsset' | translate) | lowercase }}
        </div>
        <div class="modal-footer d-flex justify-content-between" *ngIf="!serialNumberAdded">
          <button type="button" class="btn btn-success" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
          <button type="button" class="btn btn-primary" (click)="addSerialNumber()" [disabled]="!serialNumber || serialNumber == ''">{{ 'Buttons.Save' | translate }}</button>
        </div>
        <div class="modal-footer d-flex justify-content-end" *ngIf="serialNumberAdded">
            <button type="button" class="btn btn-success" (click)="loadAsset(assetId)" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
        </div>
      </div>
    </div>
</div>